export const bonuses = [
  {
    number: 1,
    title: 'PREDICTABILITY RISK MATRIX™',
    subtitle: 'Movement Risk Assessment Reference',
    value: '$37',
    image: 'https://cdn.magicpatterns.com/uploads/bHSDFfD3gvn26nxo9S9dtu/BONUS_1_PREDIC-EN.png',
    description: 'A visual reference designed to help you organize movement-related risk factors.',
    includes: [
      'Movement categories and assessment criteria.',
      'Risk-factor comparison tables.',
      'Clinical evaluation prompts.',
      'Printable assessment sheets.',
    ],
    why: 'Helps you recognize which planned movements may require closer clinical evaluation.',
  },
  {
    number: 2,
    title: 'ATTACHMENT SELECTION BLUEPRINT™',
    subtitle: 'Visual Guide to Attachment Planning Considerations',
    value: '$47',
    image: 'https://cdn.magicpatterns.com/uploads/m4GXqqhjAVCXQATVh9BmiB/BONUS_2_PREDIC-EN.png',
    description: 'A practical reference covering the biomechanical purpose of attachments in clear aligner treatment.',
    includes: [
      'Attachment function diagrams.',
      'Movement-specific considerations.',
      'Biomechanical planning questions.',
      'Visual comparison tables.',
    ],
    why: 'Supports more informed evaluation of attachment strategies rather than relying exclusively on automated recommendations.',
  },
  {
    number: 3,
    title: 'DIGITAL SETUP AUDIT CHECKLIST™',
    subtitle: 'Your Pre-Approval Clinical Review Tool',
    value: '$37',
    image: 'https://cdn.magicpatterns.com/uploads/fv79dvNWsoPgivjsUErvXF/BONUS_3_PREDIC-EN.png',
    description: 'A structured checklist to review before approving a digital treatment setup.',
    includes: [
      'Movement feasibility considerations.',
      'Sequencing review points.',
      'Space and attachment evaluation.',
      'Biomechanical warning signs.',
      'Final approval checklist.',
    ],
    why: 'Helps organize the review process and reduce the likelihood of overlooking important planning considerations.',
  },
  {
    number: 4,
    title: 'TRACKING TROUBLESHOOTING ROADMAP™',
    subtitle: 'Clinical Assessment Pathways for Aligner Tracking Problems',
    value: '$47',
    image: 'https://cdn.magicpatterns.com/uploads/obYsRb2jgLAEMXe1GXvEsi/BONUS_4_PREDIC-EN.png',
    description: 'A visual guide for investigating situations where teeth aren’t following the expected aligner progression.',
    includes: [
      'Common tracking discrepancy categories.',
      'Potential contributing factors.',
      'Clinical assessment pathways.',
      'Monitoring and reassessment criteria.',
    ],
    why: 'Gives you an organized framework for evaluating unexpected treatment progress.',
  },
  {
    number: 5,
    title: 'CLINICAL CASE PLANNING WORKBOOK™',
    subtitle: 'Printable Templates for More Organized Aligner Cases',
    value: '$37',
    image: 'https://cdn.magicpatterns.com/uploads/qw5xNy4icyxtEWDn964qqS/BONUS_5_PREDIC-EN.png',
    description: 'A collection of practical worksheets for documenting treatment planning decisions.',
    includes: [
      'Initial movement assessment sheets.',
      'Planning objective templates.',
      'Clinical risk documentation.',
      'Setup review forms.',
      'Treatment monitoring worksheets.',
    ],
    why: 'Helps keep important clinical planning information organized and accessible.',
  },
];
